import { css } from 'lit';
export default css `
  :host {
    display: block;
  }

  sl-range {
    --track-color-active: var(--amityeko-color-primary-6);
    --track-color-inactive: var(--amityeko-color-gray-8);
  }

  input[type='file'] {
    display: none;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .drag__chip {
    position: absolute;
    margin: 0 auto;
    z-index: 2;

    --amityeko-color-gray-9: rgba(66, 66, 66, 0.8);
    --amityeko-color-gray-1: var(--amityeko-color-font-light);
    --amityeko-color-gray-8: rgba(66, 66, 66, 0.9);
  }

  .image__container {
    display: flex;
  }

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    cursor: move;
  }

  .range__wrapper {
    /* Center the content */
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 20px;
  }

  #sl_range_slider {
    width: 320px;
  }

  amityeko-button {
    text-align: center;
  }

  .warning__dialog__content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .cropper-view-box {
    border-radius: 10px;
    outline: none;
  }

  .cropper-view-box > img {
    width: 200px;
    height: 320px;
  }
`;
//# sourceMappingURL=styles.js.map